export default {
  errorsRootKey: 'invoice/payment-via',
  resource: 'invoice/payment-via',
  actions: ['index', 'create', 'show', 'update', 'destroy']
}
